/**
 * Component to render SCA Risk management page
 */
const RiskManagementPage = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="risk-management-page-component"
    >
      <p>
        <strong>Objectives of the Award</strong>
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          To recognise companies that have established and disclosed adequate
          and effective risk management practices to support strategic
          direction;
        </li>
        <li>
          To highlight importance of establishing an adequate and effective risk
          management framework to generate long term sustainable success;
        </li>
        <li>
          To raise awareness of the core and leading risk management practices
          required and adopted in leading in a period of technology and
          disruption.
        </li>
      </ul>

      <p>
        <strong>Categories of the Award</strong>
      </p>

      <p>Awards will be presented in the following categories:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Companies with market capitalisation of S$1 billion and above;</li>
        <li>
          Companies with market capitalisation of S$300 million to less than S$1
          billion;
        </li>
        <li>
          Companies with market capitalisation of less than S$300 million;
        </li>
      </ul>

      <p>
        <strong>Selection and Judging Process</strong>
      </p>

      <p>
        The selection and judging process consists of a three-stage process:
      </p>

      <p className="mb-0">
        In Stage 1, all listed companies are subjected to a preliminary
        screening using the following sources:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          Corporate governance rankings eg. Singapore Governance and
          Transparency Index score and ASEAN Corporate Governance Scorecard;
        </li>
        <li>Performance results e.g. return on equity;</li>
        <li>
          Potential ‘red flags&apos; of poor risk management e.g. SGX watchlist,
          significant unplanned incidents or events (using publicly available
          information);
        </li>
      </ul>

      <p>
        In Stage 2, a final shortlist of companies is evaluated against a set of
        detailed Risk Management review criteria.
      </p>

      <p>
        In Stage 3, a panel of judges reviews and evaluates the shortlisted
        candidates based on the information provided by the companies and
        evaluators. The panel of judges will also meet with and interview
        representatives from the final shortlisted candidates and rank them.
      </p>

      <p>
        <strong>Criteria</strong>
      </p>

      <p>
        The following criteria are used to identify the final shortlist of
        companies:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          Risk strategy and appetite which is well articulated, formalised and
          integrated into the enterprise-wide decision making process at all
          levels;
        </li>
        <li>
          Formalised risk governance structure with clear roles and
          responsibilities across the various lines of defense;
        </li>
        <li>
          The extent to which the organisation&apos;s risk culture permeates
          across all levels of management and staff;
        </li>
        <li>
          A clearly defined and effective risk identification, assessment, and
          measurement process which aligns the organisations strategy;
        </li>
        <li>
          Adequate and effective risk management and internal control systems;
        </li>
        <li>
          Risk reporting and insights are timely and transparent to support
          internal and external stakeholder needs;
        </li>
        <li>
          The extent to which technology is used to enhance data quality,
          governance and risk analytics;
        </li>
      </ul>

      <p>
        In addition, the extent to which companies disclose information in
        relation to:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Innovation and Technology Governance;</li>
        <li>Sustainability Governance;</li>
        <li>Continuous Improvement of Enterprise Risk Management;</li>
      </ul>

      <div className="mt-12 text-xs">
        <p>
          For more information, please contact the Singapore Institute of
          Directors:
        </p>

        <ul className="mb-6 list-none">
          <li>Mr Edwin Lee;</li>
          <li>Email: edwin@sid.org.sg;</li>
          <li>DID: 6011 0100 / 6422 1188;</li>
        </ul>

        <ul className="list-none">
          <li>Singapore Institute of Directors;</li>
          <li>168, #11-03 Robinson Rd, Capital Tower, 068912;</li>
        </ul>
      </div>
    </div>
  );
};

export default RiskManagementPage;
